import courthouseExteriorImage from '@/images/ai-image-creator/courthouse-exterior.jpg';
import documentReviewImage from '@/images/ai-image-creator/document-review.jpg';
import legalDeskImage from '@/images/ai-image-creator/legal-desk.jpg';
import officeHandshakeImage from '@/images/ai-image-creator/office-handshake.jpg';
import type { BlogRecord } from '@/lib/blocks/collection/records';
import type { Topic } from '@/types/shared';

const PREVIEW_BLOG_IMAGES = [
  { url: legalDeskImage, alt: 'Legal desk workspace' },
  { url: documentReviewImage, alt: 'Legal document review' },
  { url: officeHandshakeImage, alt: 'Professional handshake' },
  { url: courthouseExteriorImage, alt: 'Courthouse exterior' },
] as const;

function previewBlogImage(index: number) {
  return PREVIEW_BLOG_IMAGES[index % PREVIEW_BLOG_IMAGES.length];
}

const TEMPLATE_PREVIEW_BLOG_DATA = [
  {
    id: 'preview-blog-1',
    title: 'Understanding Your Legal Rights',
    summary: 'Learn about your fundamental legal rights and how to protect them.',
    publishedAt: '2024-03-01',
    path: 'blogs/understanding-your-legal-rights',
    authors: [{ name: 'Sarah Williams' }],
    topics: [{ id: 'preview-topic-1', name: 'Legal Rights' }],
  },
  {
    id: 'preview-blog-2',
    title: 'Navigating Contract Law',
    summary: 'A practical guide to understanding contracts and legal agreements.',
    publishedAt: '2024-02-28',
    path: 'blogs/navigating-contract-law',
    authors: [{ name: 'David Brown' }],
    topics: [{ id: 'preview-topic-2', name: 'Contracts' }],
  },
  {
    id: 'preview-blog-3',
    title: 'What to Expect During a Consultation',
    summary: 'How to prepare for your first conversation with a legal team.',
    publishedAt: '2024-02-14',
    path: 'blogs/consultation-preparation',
    authors: [{ name: 'Sarah Williams' }],
    topics: [{ id: 'preview-topic-3', name: 'Planning' }],
  },
  {
    id: 'preview-blog-4',
    title: 'Steps After an Accident',
    summary: 'Important actions to take after an accident to protect your claim.',
    publishedAt: '2024-01-30',
    path: 'blogs/steps-after-an-accident',
    authors: [{ name: 'Maria Garcia' }],
    topics: [{ id: 'preview-topic-4', name: 'Personal Injury' }],
  },
];

export const TEMPLATE_PREVIEW_BLOGS: BlogRecord[] = TEMPLATE_PREVIEW_BLOG_DATA.map(
  (blog, index) => ({
    ...blog,
    image: previewBlogImage(index),
  }),
);

export const TEMPLATE_PREVIEW_TOPICS: Topic[] = [
  { id: 'preview-topic-1', name: 'Legal Rights' },
  { id: 'preview-topic-2', name: 'Contracts' },
  { id: 'preview-topic-3', name: 'Planning' },
  { id: 'preview-topic-4', name: 'Personal Injury' },
];
